import React from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  margin-top: 16px;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
`;

const Button = styled.button`
  background: white;
  border: none;
  padding: 12px 24px;
  border-radius: 50px;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(37, 99, 235, 0.2);
  }

  &:active {
    transform: scale(0.98);
  }
`;

const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  background: #eff6ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Title = styled.span`
  color: #1e40af;
  font-weight: 700;
  font-size: 16px;
`;

const Subtitle = styled.span`
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
`;

interface DashboardRecapProps {
    onViewRecap: () => void;
}

const DashboardRecap: React.FC<DashboardRecapProps> = ({ onViewRecap }) => {
    return (
        <Container>
            <Button onClick={onViewRecap}>
                <IconWrapper>✨</IconWrapper>
                <TextContent>
                    <Title>Tu Resumen 2025</Title>
                    <Subtitle>Descubre tus logros financieros</Subtitle>
                </TextContent>
                <div style={{ color: "#cbd5e1", marginLeft: 8 }}>›</div>
            </Button>
        </Container>
    );
};

export default DashboardRecap;
